import { jsonProperty, jsonClass } from '@sumbricht/json-class-serializer'

export const ScreenScrollPositionClassTargets = {
	screen: { title: 'This screen', element: 'this.elementRef.nativeElement' },
	body: { title: 'HTML body element', element: 'document.body' },
} as const
export type ScreenScrollPositionClassTarget =
	keyof typeof ScreenScrollPositionClassTargets

@jsonClass('ScreenScrollPositionClass')
export class ScreenScrollPositionClass {
	@jsonProperty(String)
	className: string = ''
	@jsonProperty(Number)
	removeIfScrollTopAtMost: number = 0
	@jsonProperty(Number)
	addIfScrollTopAbove: number = 0
	@jsonProperty(String)
	scrollableElementSelector: string = ''
	@jsonProperty(String)
	setOnTarget: ScreenScrollPositionClassTarget = 'screen'
}
